import React from 'react';

const renderPrize = ({ rank, award, percentage }, chipValue) => {
  return (
    <div className="tournaments__lobby__prize" key={rank}>
      <div className="tournaments__lobby__prize-place">
        {rank}
      </div>
      <div className="tournaments__lobby__prize-sum">
        {chipValue({ val: award.amount, margin: 4 })}
      </div>
      <div className="tournaments__lobby__prize-percentage">
        {`${Math.round(percentage)}%`}
      </div>
    </div>
  );
}


export const renderPrizePool = (prizes, showMorePrizes, isMobile = null, showMorePrizesMobile = null, chipValue) => {
  const showPrizesForMobile = [...prizes].slice(0, 3);
  const showMorePrizesForMobile = [...prizes].slice(3);

  return (
    <React.Fragment>
      <div className="tournaments__lobby__prizes--mobile">
        {showPrizesForMobile.map(item => renderPrize(item, chipValue))}
        {showMorePrizesMobile && showMorePrizesForMobile.map(item => renderPrize(item, chipValue))}
      </div>
    </React.Fragment>
  );
}
